var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EdgelessPresentationConsts as PresentationConsts, } from '@blocksuite/blocks';
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
const styles = css `
  :host {
    display: block;
    box-sizing: border-box;
    padding: 8px;
    width: 220px;
  }

  .frames-setting-menu-container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
  }

  .frames-setting-menu-item {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 28px;
    padding: 4px 12px;
    align-items: center;
  }

  .frames-setting-menu-item .setting-label {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: var(--affine-text-secondary-color);
    padding: 0 4px;
  }

  .frames-setting-menu-divider {
    width: 100%;
    height: 1px;
    box-sizing: border-box;
    background: var(--affine-border-color);
    margin: 8px 0;
  }

  .frames-setting-menu-item.action {
    gap: 4px;
  }

  .frames-setting-menu-item .action-label {
    width: 138px;
    height: 20px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: var(--affine-text-primary-color);
  }

  .frames-setting-menu-item .toggle-button {
    display: flex;
  }

  menu-divider {
    height: 16px;
  }
`;
export class FramesSettingMenu extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this.blackBackground = false;
        this.fillScreen = false;
        this.hideToolbar = false;
        this._onBlackBackgroundChange = (checked) => {
            this.blackBackground = checked;
            this.edgeless?.slots.navigatorSettingUpdated.emit({
                blackBackground: this.blackBackground,
            });
        };
        this._onFillScreenChange = (checked) => {
            this.fillScreen = checked;
            this.edgeless?.slots.navigatorSettingUpdated.emit({
                fillScreen: this.fillScreen,
            });
            sessionStorage.setItem(PresentationConsts.FillScreen, this.fillScreen.toString());
        };
        this._onHideToolBarChange = (checked) => {
            this.hideToolbar = checked;
            this.edgeless?.slots.navigatorSettingUpdated.emit({
                hideToolbar: this.hideToolbar,
            });
            sessionStorage.setItem(PresentationConsts.HideToolbar, this.hideToolbar.toString());
        };
    }
    _tryRestoreSettings() {
        const blackBackground = sessionStorage.getItem(PresentationConsts.BlackBackground);
        const fillScreen = sessionStorage.getItem(PresentationConsts.FillScreen);
        const hideToolbar = sessionStorage.getItem(PresentationConsts.HideToolbar);
        this.blackBackground = blackBackground === 'true';
        this.fillScreen = fillScreen === 'true';
        this.hideToolbar = hideToolbar === 'true';
    }
    connectedCallback() {
        super.connectedCallback();
        this._tryRestoreSettings();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    updated(_changedProperties) {
        if (_changedProperties.has('edgeless')) {
            if (this.edgeless) {
                this.disposables.add(this.edgeless.slots.navigatorSettingUpdated.on(({ blackBackground, hideToolbar }) => {
                    if (blackBackground !== undefined &&
                        blackBackground !== this.blackBackground) {
                        this.blackBackground = blackBackground;
                    }
                    if (hideToolbar !== undefined &&
                        hideToolbar !== this.hideToolbar) {
                        this.hideToolbar = hideToolbar;
                    }
                }));
            }
            else {
                this.disposables.dispose();
            }
        }
    }
    render() {
        return html `<div
      class="frames-setting-menu-container"
      @click=${(e) => {
            e.stopPropagation();
        }}
    >
      <div class="frames-setting-menu-item">
        <div class="setting-label">Preview Settings</div>
      </div>
      <div class="frames-setting-menu-item action">
        <div class="action-label">Fill Screen</div>
        <div class="toggle-button">
          <toggle-switch
            .on=${this.fillScreen}
            .onChange=${this._onFillScreenChange}
          ></toggle-switch>
        </div>
      </div>

      <menu-divider></menu-divider>

      <div class="frames-setting-menu-item">
        <div class="setting-label">Playback Settings</div>
      </div>
      <div class="frames-setting-menu-item action">
        <div class="action-label">Dark background</div>
        <div class="toggle-button">
          <toggle-switch
            .on=${this.blackBackground}
            .onChange=${this._onBlackBackgroundChange}
          ></toggle-switch>
        </div>
      </div>
      <div class="frames-setting-menu-item action">
        <div class="action-label">Hide toolbar</div>
        <div class="toggle-button">
          <toggle-switch
            .on=${this.hideToolbar}
            .onChange=${this._onHideToolBarChange}
          ></toggle-switch>
        </div>
      </div>
    </div>`;
    }
}
FramesSettingMenu.styles = styles;
__decorate([
    property({ attribute: false })
], FramesSettingMenu.prototype, "edgeless", void 0);
__decorate([
    state()
], FramesSettingMenu.prototype, "blackBackground", void 0);
__decorate([
    state()
], FramesSettingMenu.prototype, "fillScreen", void 0);
__decorate([
    state()
], FramesSettingMenu.prototype, "hideToolbar", void 0);
//# sourceMappingURL=frames-setting-menu.js.map